import { CookieHelper } from '../../common/helpers/cookie-helper';
import { IPortalConfig } from './i-portal-config';
import { PortalConfigMap } from './portal-config-map';
import { PortalType } from './portal-type';

export class PortalConfigHelper {
  private static instance: PortalConfigHelper;
  private portalConfig!: IPortalConfig;
  private constructor() {}

  static getInstance() {
    if (!this.instance) {
      this.instance = new PortalConfigHelper();
    }
    return this.instance;
  }

  //Returns required portal config based on the URL
  getPortalConfig(): IPortalConfig {
    if (this.portalConfig) {
      return this.portalConfig;
    }
    const host = window.location.host;
    //get portal identifier for ex. parter from partner.microsoft.com
    const portalType = host.substring(0, host.indexOf('.'));
    const fdType = CookieHelper.get('FDType');
    let portalConfig = PortalConfigMap[portalType];
    //If partner portal is served through multiportal then apply related config
    //TODO: temp fix for pcshell route
    if (portalType === PortalType.Partner && fdType?.toLocaleLowerCase() === 'multiportal') {
      portalConfig = PortalConfigMap[PortalType.PartnerMP];
    }
    //default
    if (!portalConfig) {
      portalConfig = PortalConfigMap[PortalType.Partner];
    }
    this.portalConfig = portalConfig;
    return portalConfig;
  }
}
